import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommissionReportService } from '@pg-app/partner/commission-report/commission-report.service';
import { UtilityService } from '@nttp/common-service/utility-service';
import { DownloadFileTypeEnum } from '@nttp/enum/download-file-type-enum';

@Component({
  selector: 'np-vat-statement',
  templateUrl: './vat-statement.component.html',
  styleUrls: ['./vat-statement.component.scss']
})

export class VatStatementComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commissionService: CommissionReportService,
    private utilityService: UtilityService
  ) { }

  downloadTemplate() {
    this.commissionService.downloadVATDocument().subscribe(res => {
      const fileName = `VAT Treatment of Introducers.pdf`;
      this.viewPDF(res, fileName);
    });
  }

  viewPDF(data: any, fileName: string) {
    this.utilityService.downloadFile(data, fileName, DownloadFileTypeEnum.PDF);
  }
}
